import type React from "react";
import { getColor, type Props } from "~/components/icons/helper";

export const CheckIcon: React.FC<Props> = ({ color }) => {
	const stroke = getColor(color);
	return (
		<svg
			role="img"
			aria-label="Check"
			width="30"
			height="21"
			viewBox="0 0 30 21"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1 9L10.2752 19.2027C10.6664 19.6331 11.341 19.64 11.7411 19.2178L29 1"
				stroke={stroke}
				strokeLinecap="round"
			/>
		</svg>
	);
};
